import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon, FontAwesomeLayers } from '@fortawesome/vue-fontawesome'

import {
  faShoppingBasket, faGrinBeamSweat, faTools, faUtensils, faBook, faSearch, faBackspace,
  faBars, faPlusCircle, faSlidersH, faEdit, faSquare, faCheckSquare, faClipboardList, faCashRegister, faTimesCircle,
  faAngleUp, faAngleDown, faPenSquare, faTrash, faUndo, faTimes, faCheck, faSignOutAlt, faArrowLeft, faArrowRight,
  faCog, faSync
} from '@fortawesome/free-solid-svg-icons'

import {
  faCalendarAlt, faQuestionCircle
} from '@fortawesome/free-regular-svg-icons'

export default {
  install (Vue, options) {
    library.add(
      faShoppingBasket, faGrinBeamSweat, faTools, faUtensils, faBook, faSearch, faBackspace,
      faBars, faPlusCircle, faSlidersH, faEdit, faSquare, faCheckSquare, faClipboardList, faCashRegister, faTimesCircle,
      faAngleUp, faAngleDown, faPenSquare, faTrash, faUndo, faTimes, faCheck, faSignOutAlt, faArrowLeft, faArrowRight,
      faCog, faSync, faCalendarAlt, faQuestionCircle
    )

    Vue.component('fa-icon', FontAwesomeIcon)
    Vue.component('fa-layers', FontAwesomeLayers)
  }
}
